// Where a candidate reviewer works, and whether they run the place.
//
// Both halves matter when picking who reviews a requerimiento: the dependency
// says whether this person knows the file, and leading it says their sign-off
// settles the matter rather than passing it along. Kept pure so the dialog can
// render it and a test can check it.

export const dependenciesOfUser = (candidate, groups) => {
  const id = candidate?.userId;
  if (!id) return [];
  return (groups || [])
    .filter(
      (g) =>
        (Array.isArray(g.memberIds) && g.memberIds.includes(id)) ||
        (Array.isArray(g.supervisorIds) && g.supervisorIds.includes(id))
    )
    .map((g) => ({
      id: g.id,
      name: g.name || g.id,
      // A dependency lead is in their dependency as much as its members are,
      // so supervision is a property of the membership, not a separate list.
      supervisor: Array.isArray(g.supervisorIds) && g.supervisorIds.includes(id),
    }));
};

// What to show on the right of a name. With a dependency chosen, only that one
// is relevant — repeating the others would just be noise in a filtered list.
export const describeDependencies = (candidate, groups, groupFilter) => {
  const all = dependenciesOfUser(candidate, groups);
  const shown = groupFilter ? all.filter((g) => g.id === groupFilter) : all;
  return {
    names: shown.map((g) => g.name),
    // Named a supervisor of what is on screen, not of some other dependency.
    supervisor: shown.some((g) => g.supervisor),
    // The fallback for someone the PQRSD module has no dependency for.
    fallback: shown.length ? "" : candidate?.dependence || "Sin dependencia",
  };
};
